import { render, staticRenderFns } from "./ModalCastigoDisposicion.vue?vue&type=template&id=bb14f8fa&"
import script from "./ModalCastigoDisposicion.vue?vue&type=script&lang=js&"
export * from "./ModalCastigoDisposicion.vue?vue&type=script&lang=js&"
import style0 from "./ModalCastigoDisposicion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports